import { Link } from "react-router-dom";
import { useState, useEffect } from "react";

const ForgetPassword = () => {
  const [email, setEmail] = useState("");
  const [isValid, setIsValid] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  useEffect(() => {
    const isEmailValid = validateEmail(email);
    setIsValid(isEmailValid);
    if (isSubmitted && !isEmailValid) {
      setErrorMessage("Please enter a valid email address");
    } else {
      setErrorMessage("");
    }
  }, [email, isSubmitted]);

  const IMG = (imgName) => {
    return `assets/landingpage/images/${imgName}`;
  };

  const validateForm = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) {
      setErrorMessage("Email is required");
      return false;
    }
    if (!emailRegex.test(email)) {
      setErrorMessage("Please enter a valid email address");
      return false;
    }
    setErrorMessage("");
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitted(true);

    if (!validateForm()) {
      return;
    }

    setLoading(true);
    try {
      // await forgotPasswordApi(email);
      // navigate("/reset-password");
    } catch (error) {
      setErrorMessage(error.response?.data?.detail || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="vh-100">
      <div className="d-flex flex-column flex-md-row h-100 ">
        {/* Left Panel */}
        <div className="d-flex w-58 max-md-w-100 login-banner-container">
          <div className="d-flex flex-grow-1 flex-column justify-content-center align-items-center">
            <img
              loading="lazy"
              src={IMG("Forgot Pswrd.jpg")}
              alt="Login illustration"
              className="illustration-image"
              style={{
                mixBlendMode: "multiply",
              }}
            />
          </div>
        </div>

        {/* Right Panel */}
        <div className="flex-grow-1 d-flex align-items-center bg-white">
          <main className="login-signup-data d-flex flex-column justify-content-center py-4 h-100 w-100 text-lg font-bold bg-white">
            <div className="text-center mb-4">
              <a
                href="/"
                className="d-flex justify-content-center image-container"
                data-discover="true"
              >
                <img
                  loading="lazy"
                  src="assets/images/logo.svg"
                  alt="Company logo"
                  className="z-10  m-0  w-120 md-w-173   company-image"
                />
              </a>
              <h1 className="mt-3 text-dark fw-bold fs-1">Forgot Password</h1>
              <p className="mt-2 text-muted">
                Enter your email and we'll send you a link to reset your
                password
              </p>
            </div>

            <form action="assets/forgot/password/mail" className="w-100">
              <input
                type="hidden"
                name="_token"
                value="xvHBbNIMgDVpVVHKBYmQiyZe0fhVZzsXcaCgvHgM"
              />

              {/* Email Field */}
              <div className="form__group">
                <input
                  type="email"
                  className="form__field"
                  placeholder="Email"
                  name="email"
                  id="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value.trim())}
                />
                <label htmlFor="email" className="form__label">
                  Email ID<span className="text-danger">*</span>
                </label>
                <img
                  loading="lazy"
                  src={IMG("inbox.svg")}
                  alt=""
                  aria-hidden="true"
                  className="input-icon"
                />
              </div>

              {errorMessage && (
                <div className="text-danger small">{errorMessage}</div>
              )}

              {/* Submit Button */}
              <button
                type="submit"
                className="btn btn-info text-white rounded-pill w-100 login-button mt-3"
                disabled={loading}
                onClick={handleSubmit}
              >
                {loading ? "Submitting..." : "Submit"}
              </button>
              {loading && (
                <div className="loader-container">
                  <div className="loader"></div>
                </div>
              )}

              {/* Back to Login */}
              <Link
                className="d-flex align-items-center justify-content-center mt-4 text-info fw-bold text-decoration-none"
                to="/login"
              >
                <img
                  loading="lazy"
                  src={IMG("leftarrow.svg")}
                  alt=""
                  className="img-fluid me-2"
                  style={{ width: "30px" }}
                />
                Back to Login
              </Link>
            </form>
          </main>
        </div>
      </div>
    </section>
  );
};

export default ForgetPassword;
